<button class="close-button" (click)="onNoClick()">
  <span aria-hidden="true">&times;</span>
</button>
<h1 mat-dialog-title class="pop-up-title">Attestation Required</h1>
<div mat-dialog-content>
  <p>I understand that each person using Windows 365 Business with Windows Hybrid Benefit also needs to have a valid
    copy of Windows 10/11 Pro installed on their primary work device.</p>
</div>
<div class="nce-dialog-action">
  <button mat-button class="button button-red button-large nce-large-button continue"
    (click)="continueSaveSubscription()">I Agree</button>

  <button mat-button class="button button-red button-large nce-large-button continue"
    (click)="cancelSaveSubscription()">Disagree</button>
</div>
